/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'g_communication': {
    width: 16,
    height: 16,
    viewBox: '0 0 51.38 56.69',
    data: '<path pid="0" d="M48.48 42.77a24.77 24.77 0 11-.66-29.73l2.81-2.22a28.34 28.34 0 10.76 34z" _fill="#fff"/><path pid="1" _fill="#fff" d="M41.33 39.92V20.78l6.46 3.99 1.86-3.01-10.21-6.3-9.97 6.31 1.89 2.99 6.44-4.08v19.24h3.53zM21.54 15.67V34.8l-6.45-3.98-1.86 3.01 10.2 6.29 9.97-6.31-1.89-2.98-6.44 4.07V15.67h-3.53z"/>'
  }
})
